var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('YA_Snackbar',{ref:"YA_SnackbarRef"}),_c('TopView'),_c('YA_Loading'),_c('v-main',[_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }